import { LoadingButton } from '@mui/lab';
import { Button, Grid, MenuItem, TextField } from '@mui/material';
import { ResponsiveDialog, ResponsiveDialogActions, ResponsiveDialogContent, ResponsiveDialogTitle } from 'components';
import { CompanyDto, LaborClassificationDto, LaborSubclassDto, laborSubclassValidationSchema } from 'dtos';
import { Form, Formik } from 'formik';

interface AddEditLaborSubclassDialogProps {
  companies: CompanyDto[];
  isLoading?: boolean;
  laborClassifications: LaborClassificationDto[];
  laborSubclass: LaborSubclassDto;
  onClose: () => void;
  onSave: (values: LaborSubclassDto) => void;
  open: boolean;
}

export default function AddEditLaborSubclassDialog({
  companies,
  isLoading,
  laborClassifications,
  laborSubclass,
  onClose,
  onSave,
  open
}: AddEditLaborSubclassDialogProps) {
  return (
    <ResponsiveDialog open={open}>
      <Formik
        enableReinitialize
        initialValues={laborSubclass}
        onSubmit={values => {
          onSave(values);
        }}
        validateOnBlur
        validateOnChange
        validationSchema={laborSubclassValidationSchema}
      >
        {({ errors, handleBlur, handleChange, touched, values }) => (
          <Form>
            <ResponsiveDialogContent>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <ResponsiveDialogTitle>Add/Edit Labor Subclass</ResponsiveDialogTitle>
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    disabled={isLoading}
                    error={Boolean(touched.companyId && errors.companyId)}
                    fullWidth
                    helperText={touched.companyId && errors.companyId}
                    label='Company'
                    name='companyId'
                    onBlur={handleBlur}
                    onChange={handleChange}
                    select
                    size='small'
                    value={values.companyId}
                  >
                    {companies.map(company => (
                      <MenuItem key={company.id} value={company.id}>
                        {company.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    disabled={isLoading}
                    error={Boolean(touched.laborClassificationId && errors.laborClassificationId)}
                    fullWidth
                    helperText={touched.laborClassificationId && errors.laborClassificationId}
                    label='Labor Classification'
                    name='laborClassificationId'
                    onBlur={handleBlur}
                    onChange={handleChange}
                    select
                    size='small'
                    value={values.laborClassificationId}
                  >
                    {laborClassifications.map(laborClassification => (
                      <MenuItem key={laborClassification.id} value={laborClassification.id}>
                        {laborClassification.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    disabled={isLoading}
                    error={Boolean(touched.name && errors.name)}
                    fullWidth
                    helperText={touched.name && errors.name}
                    label='Name'
                    name='name'
                    onBlur={handleBlur}
                    onChange={handleChange}
                    size='small'
                    value={values.name}
                  />
                </Grid>
              </Grid>
            </ResponsiveDialogContent>

            <ResponsiveDialogActions>
              <Button color='error' disabled={isLoading} onClick={onClose}>
                CANCEL
              </Button>

              <LoadingButton color='primary' loading={isLoading} type='submit'>
                SAVE
              </LoadingButton>
            </ResponsiveDialogActions>
          </Form>
        )}
      </Formik>
    </ResponsiveDialog>
  );
}
